// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__s4ytl","rootCenter":"LoadMoreObserver_rootCenter__1yIOn","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__ZyDav"};